export default "__VITE_ASSET__DlZxuT1K__"